import { Company } from 'interfaces/company'
import { getHoursFromMinutes } from 'lib/util/date'

const classNames = {
  cardItem: 'tw-mb-4 tw-flex tw-items-center tw-justify-between',
  cardWrapper: 'tw-w-1/2 tw-p-4 tw-block tw-overflow-x-auto tw-bg-white tw-rounded-lg tw-shadow-md',
  container: 'tw-container tw-px-3',
  header: 'tw-flex tw-justify-between tw-mb-4',
  wrapper: 'tw-flex tw-w-full tw-flex-col',
}

export default function BillingPage({ company }: { company: Company }) {
  const platformName = company.platform.base ? 'Base' : company.platform.pro ? 'Pro' : 'Not subscribed'
  console.log('company', company)

  return (
    <div className={classNames.wrapper}>
      <div className={classNames.header}>
        <h4>Manage Your Subscription</h4>
      </div>
      <div className={classNames.container}>
        <div className={classNames.cardWrapper}>
          <div className={classNames.cardItem}>
            <strong>Your Subscription</strong>
            <div>Manage subscription</div>
          </div>
          <div className={classNames.cardItem} data-testid="platform">
            <div>Platform</div>
            <div>{platformName}</div>
          </div>
          <div className={classNames.cardItem} data-testid="base-service">
            <div>Creative services</div>
            <div>{`${getHoursFromMinutes(company.serviceBaseMinutes)} (daily)`}</div>
          </div>
          <div className={classNames.cardItem} data-testid="plus-service">
            <div>Additional design hours</div>
            <div>{`${getHoursFromMinutes(company.servicePlusMinutes)} (daily)`}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
